import appsettings from '../../appsettings.js';
import Mgr from '../../SecurityService'
import axios from "axios";

var mgr = new Mgr();

const state = {
    VrsUser: {},
    Permissions: [],
    activeTrip: false,
    activeOrder: 0
};

const getters = {
    getVrsUser: state => state.VrsUser,
    getPermissions: state => state.Permissions,
    getRefreshActiveTrip: state => state.activeTrip,
    getActiveOrder: state => state.activeOrder,
    hasAccess: state => featureId => {
        let permission = state.Permissions.find(item => item.featureId === featureId)
        if (permission) return permission.isGranted
        else return false
    }
};

const actions = {
    async refreshActiveTrip({ commit, state }, refresh) {

        const refreshx = state.activeTrip;

        commit('setRefreshActiveTrip', !refreshx);
    },
    async loadVrsUserInfo({ commit, dispatch }) {
        let username=await mgr.getUsername();
        let response = await axios.get(`/api/User/${username}`);
        let data=response.data;
        data.showActiveMaterials = data.showActiveMaterials ?? appsettings.default.showActiveMaterials;
        data.pageSize = data.pageSize ?? appsettings.default.pageSize;
        data.showPricing = data.showPricing ?? appsettings.default.showPricing;
        commit('setVrsUser', data);
        dispatch('loadVrsUserPermissions', data.roleId);
        
    },
    async loadVrsUserPermissions({ commit }, roleId) {
        let response = await axios.get(`/api/Role/${roleId}/features`);
        let data=response.data;
        commit('setVrsUserPermissions', data);
    },
    
    async updateVrsUserInfo({ commit, dispatch }, newVrsUserInfo) {
        
        await axios.put("/api/user",newVrsUserInfo);
        commit('setVrsUser', newVrsUserInfo);
        dispatch('loadVrsUserPermissions', newVrsUserInfo.roleId);
    },

    async switchActiveOrder({ commit }, orderId) {
        commit("setActiveOrder", orderId)
    },

    getPermissions(){
        return mgr.getUsername()
        .then(username => axios.get(`/api/User/${username}`))
        .then(response => axios.get(`/api/Role/${response.data.roleId}/features`))
        .then(response => response.data.map(item => {
            return { "featureId": item.featureId, "isGranted": item.isGranted }
        }));
    }   
};

const mutations = {
    setVrsUser: (state, VrsUser) => (state.VrsUser = VrsUser),
    setVrsUserPermissions: (state, Permissions) => (state.Permissions = Permissions),
    setRefreshActiveTrip: (state, refresh) => (state.activeTrip = refresh),
    setActiveOrder: (state,orderId) => (state.activeOrder = orderId)
};

export default {
    state,
    getters,
    actions,
    mutations
}